export const UNITED_ARAB_EMIRATES_PROVINCE_CODES = {
    AZ: 'Abu Dhabi',
    AJ: 'Ajman',
    DU: 'Dubai',
    FU: 'Fujairah',
    RK: 'Ras al-Khaimah',
    SH: 'Sharjah',
    UQ: 'Umm al-Quwain',
};
export const UNITED_STATES_PROVINCE_CODES = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'District of Columbia',
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands',
    PR: 'Puerto Rico',
    VI: 'Virgin Islands',
    FM: 'Federated States of Micronesia',
    MH: 'Marshall Islands',
    PW: 'Palau',
    AA: 'Armed Forces Americas',
    AE: 'Armed Forces Europe',
    AP: 'Armed Forces Pacific',
};
export const SPAIN_PROVINCE_CODES = {
    C: 'A Coruña',
    VI: 'Álava',
    AB: 'Albacete',
    A: 'Alicante',
    AL: 'Almería',
    O: 'Asturias',
    AV: 'Ávila',
    BA: 'Badajoz',
    PM: 'Balears',
    B: 'Barcelona',
    BU: 'Burgos',
    CC: 'Cáceres',
    CA: 'Cádiz',
    S: 'Cantabria',
    CS: 'Castellón',
    CE: 'Ceuta',
    CR: 'Ciudad Real',
    CO: 'Córdoba',
    CU: 'Cuenca',
    GI: 'Girona',
    GR: 'Granada',
    GU: 'Guadalajara',
    SS: 'Guipúzcoa',
    H: 'Huelva',
    HU: 'Huesca',
    J: 'Jaén',
    LO: 'La Rioja',
    GC: 'Las Palmas',
    LE: 'León',
    L: 'Lleida',
    LU: 'Lugo',
    M: 'Madrid',
    MA: 'Málaga',
    ML: 'Melilla',
    MU: 'Murcia',
    NA: 'Navarra',
    OR: 'Ourense',
    P: 'Palencia',
    PO: 'Pontevedra',
    SA: 'Salamanca',
    TF: 'Santa Cruz de Tenerife',
    SG: 'Segovia',
    SE: 'Sevilla',
    SO: 'Soria',
    T: 'Tarragona',
    TE: 'Teruel',
    TO: 'Toledo',
    V: 'Valencia',
    VA: 'Valladolid',
    BI: 'Vizcaya',
    ZA: 'Zamora',
    Z: 'Zaragoza',
};
export const UNITED_KINGDOM_PROVINCE_CODES = {
    BFP: 'British Forces',
    ENG: 'England',
    NIR: 'Northern Ireland',
    SCT: 'Scotland',
    WLS: 'Wales',
};
export const HONG_KONG_PROVINCE_CODES = {
    HK: 'Hong Kong Island',
    KL: 'Kowloon',
    NT: 'New Territories',
};
export const IRELAND_PROVINCE_CODES = {
    CW: 'Carlow',
    CN: 'Cavan',
    CE: 'Clare',
    CO: 'Cork',
    DL: 'Donegal',
    D: 'Dublin',
    G: 'Galway',
    KY: 'Kerry',
    KE: 'Kildare',
    KK: 'Kilkenny',
    LS: 'Laois',
    LM: 'Leitrim',
    LK: 'Limerick',
    LD: 'Longford',
    LH: 'Louth',
    MO: 'Mayo',
    MH: 'Meath',
    MN: 'Monaghan',
    OY: 'Offaly',
    RN: 'Roscommon',
    SO: 'Sligo',
    TA: 'Tipperary',
    WD: 'Waterford',
    WH: 'Westmeath',
    WX: 'Wexford',
    WW: 'Wicklow',
};
export const ITALY_PROVINCE_CODES = {
    AG: 'Agrigento',
    AL: 'Alessandria',
    AN: 'Ancona',
    AO: 'Aosta',
    AR: 'Arezzo',
    AP: 'Ascoli Piceno',
    AT: 'Asti',
    AV: 'Avellino',
    BA: 'Bari',
    BT: 'Barletta-Andria-Trani',
    BL: 'Belluno',
    BN: 'Benevento',
    BG: 'Bergamo',
    BI: 'Biella',
    BO: 'Bologna',
    BZ: 'Bolzano',
    BS: 'Brescia',
    BR: 'Brindisi',
    CA: 'Cagliari',
    CL: 'Caltanissetta',
    CB: 'Campobasso',
    CI: 'Carbonia-Iglesias',
    CE: 'Caserta',
    CT: 'Catania',
    CZ: 'Catanzaro',
    CH: 'Chieti',
    CO: 'Como',
    CS: 'Cosenza',
    CR: 'Cremona',
    KR: 'Crotone',
    CN: 'Cuneo',
    EN: 'Enna',
    FM: 'Fermo',
    FE: 'Ferrara',
    FI: 'Firenze',
    FG: 'Foggia',
    FC: 'Forlì-Cesena',
    FR: 'Frosinone',
    GE: 'Genova',
    GO: 'Gorizia',
    GR: 'Grosseto',
    IM: 'Imperia',
    IS: 'Isernia',
    AQ: "L'Aquila",
    SP: 'La Spezia',
    LT: 'Latina',
    LE: 'Lecce',
    LC: 'Lecco',
    LI: 'Livorno',
    LO: 'Lodi',
    LU: 'Lucca',
    MC: 'Macerata',
    MN: 'Mantova',
    MS: 'Massa-Carrara',
    MT: 'Matera',
    VS: 'Medio Campidano',
    ME: 'Messina',
    MI: 'Milano',
    MO: 'Modena',
    MB: 'Monza e Brianza',
    NA: 'Napoli',
    NO: 'Novara',
    NU: 'Nuoro',
    OG: 'Ogliastra',
    OT: 'Olbia-Tempio',
    OR: 'Oristano',
    PD: 'Padova',
    PA: 'Palermo',
    PR: 'Parma',
    PV: 'Pavia',
    PG: 'Perugia',
    PU: 'Pesaro e Urbino',
    PE: 'Pescara',
    PC: 'Piacenza',
    PI: 'Pisa',
    PT: 'Pistoia',
    PN: 'Pordenone',
    PZ: 'Potenza',
    PO: 'Prato',
    RG: 'Ragusa',
    RA: 'Ravenna',
    RC: 'Reggio Calabria',
    RE: 'Reggio Emilia',
    RI: 'Rieti',
    RN: 'Rimini',
    RM: 'Roma',
    RO: 'Rovigo',
    SA: 'Salerno',
    SS: 'Sassari',
    SV: 'Savona',
    SI: 'Siena',
    SR: 'Siracusa',
    SO: 'Sondrio',
    TA: 'Taranto',
    TE: 'Teramo',
    TR: 'Terni',
    TO: 'Torino',
    TP: 'Trapani',
    TN: 'Trento',
    TV: 'Treviso',
    TS: 'Trieste',
    UD: 'Udine',
    VA: 'Varese',
    VE: 'Venezia',
    VB: 'Verbano-Cusio-Ossola',
    VC: 'Vercelli',
    VR: 'Verona',
    VV: 'Vibo Valentia',
    VI: 'Vicenza',
    VT: 'Viterbo',
};
export const JAPAN_PROVINCE_CODES = {
    'JP-23': 'Aichi',
    'JP-05': 'Akita',
    'JP-02': 'Aomori',
    'JP-12': 'Chiba',
    'JP-38': 'Ehime',
    'JP-18': 'Fukui',
    'JP-40': 'Fukuoka',
    'JP-07': 'Fukushima',
    'JP-21': 'Gifu',
    'JP-10': 'Gunma',
    'JP-34': 'Hiroshima',
    'JP-01': 'Hokkaidō',
    'JP-28': 'Hyōgo',
    'JP-08': 'Ibaraki',
    'JP-17': 'Ishikawa',
    'JP-03': 'Iwate',
    'JP-37': 'Kagawa',
    'JP-46': 'Kagoshima',
    'JP-14': 'Kanagawa',
    'JP-39': 'Kōchi',
    'JP-43': 'Kumamoto',
    'JP-26': 'Kyōto',
    'JP-24': 'Mie',
    'JP-04': 'Miyagi',
    'JP-45': 'Miyazaki',
    'JP-20': 'Nagano',
    'JP-42': 'Nagasaki',
    'JP-29': 'Nara',
    'JP-15': 'Niigata',
    'JP-44': 'Ōita',
    'JP-33': 'Okayama',
    'JP-47': 'Okinawa',
    'JP-27': 'Ōsaka',
    'JP-41': 'Saga',
    'JP-11': 'Saitama',
    'JP-25': 'Shiga',
    'JP-32': 'Shimane',
    'JP-22': 'Shizuoka',
    'JP-09': 'Tochigi',
    'JP-36': 'Tokushima',
    'JP-13': 'Tōkyō',
    'JP-31': 'Tottori',
    'JP-16': 'Toyama',
    'JP-30': 'Wakayama',
    'JP-06': 'Yamagata',
    'JP-35': 'Yamaguchi',
    'JP-19': 'Yamanashi',
};
export const KOREA_REPUBLIC_OF_PROVINCE_CODES = {
    'KR-26': 'Busan',
    'KR-43': 'Chungbuk',
    'KR-44': 'Chungnam',
    'KR-27': 'Daegu',
    'KR-30': 'Daejeon',
    'KR-42': 'Gangwon',
    'KR-29': 'Gwangju',
    'KR-47': 'Gyeongbuk',
    'KR-41': 'Gyeonggi',
    'KR-48': 'Gyeongnam',
    'KR-28': 'Incheon',
    'KR-49': 'Jeju',
    'KR-45': 'Jeonbuk',
    'KR-46': 'Jeonnam',
    'KR-50': 'Sejong',
    'KR-11': 'Seoul',
    'KR-31': 'Ulsan',
};
export const CANADA_PROVINCE_CODES = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    YT: 'Yukon',
};
export const AUSTRALIA_PROVINCE_CODES = {
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia',
};
export const MEXICO_PROVINCE_CODES = {
    AGS: 'Aguascalientes',
    BC: 'Baja California',
    BCS: 'Baja California Sur',
    CAMP: 'Campeche',
    CHIS: 'Chiapas',
    CHIH: 'Chihuahua',
    DF: 'Ciudad de México',
    COAH: 'Coahuila',
    COL: 'Colima',
    DGO: 'Durango',
    GTO: 'Guanajuato',
    GRO: 'Guerrero',
    HGO: 'Hidalgo',
    JAL: 'Jalisco',
    MEX: 'México',
    MICH: 'Michoacán',
    MOR: 'Morelos',
    NAY: 'Nayarit',
    NL: 'Nuevo León',
    OAX: 'Oaxaca',
    PUE: 'Puebla',
    QRO: 'Querétaro',
    'Q ROO': 'Quintana Roo',
    SLP: 'San Luis Potosí',
    SIN: 'Sinaloa',
    SON: 'Sonora',
    TAB: 'Tabasco',
    TAMPS: 'Tamaulipas',
    TLAX: 'Tlaxcala',
    VER: 'Veracruz',
    YUC: 'Yucatán',
    ZAC: 'Zacatecas',
};
export const MALAYSIA_PROVINCE_CODES = {
    JHR: 'Johor',
    KDH: 'Kedah',
    KTN: 'Kelantan',
    KUL: 'Kuala Lumpur',
    LBN: 'Labuan',
    MLK: 'Melaka',
    NSN: 'Negeri Sembilan',
    PHG: 'Pahang',
    PNG: 'Penang',
    PRK: 'Perak',
    PLS: 'Perlis',
    PJY: 'Putrajaya',
    SBH: 'Sabah',
    SWK: 'Sarawak',
    SGR: 'Selangor',
    TRG: 'Terengganu',
};
export const NEW_ZEALAND_PROVINCE_CODES = {
    AUK: 'Auckland',
    BOP: 'Bay of Plenty',
    CAN: 'Canterbury',
    CIT: 'Chatham Islands',
    GIS: 'Gisborne',
    HKB: "Hawke's Bay",
    MWT: 'Manawatu-Wanganui',
    MBH: 'Marlborough',
    NSN: 'Nelson',
    NTL: 'Northland',
    OTA: 'Otago',
    STL: 'Southland',
    TKI: 'Taranaki',
    TAS: 'Tasman',
    WKO: 'Waikato',
    WGN: 'Wellington',
    WTC: 'West Coast',
};
export const PORTUGAL_PROVINCE_CODES = {
    'PT-20': 'Açores',
    'PT-01': 'Aveiro',
    'PT-02': 'Beja',
    'PT-03': 'Braga',
    'PT-04': 'Bragança',
    'PT-05': 'Castelo Branco',
    'PT-06': 'Coimbra',
    'PT-07': 'Évora',
    'PT-08': 'Faro',
    'PT-09': 'Guarda',
    'PT-10': 'Leiria',
    'PT-11': 'Lisboa',
    'PT-30': 'Madeira',
    'PT-12': 'Portalegre',
    'PT-13': 'Porto',
    'PT-14': 'Santarém',
    'PT-15': 'Setúbal',
    'PT-16': 'Viana do Castelo',
    'PT-17': 'Vila Real',
    'PT-18': 'Viseu',
};
export const AUSTRIA_PROVINCE_CODES = {
    BL: 'Burgenland',
    KN: 'Carinthia',
    NO: 'Lower Austria',
    SZ: 'Salzburg',
    ST: 'Styria',
    TY: 'Tyrol',
    UA: 'Upper Austria',
    VI: 'Vienna',
    VO: 'Vorarlberg',
};
export const BELGIUM_PROVINCE_CODES = {
    BR: 'Brussels-Capital',
    VW: 'Flemish Brabant',
    HW: 'Hainaut',
    LG: 'Liège',
    LX: 'Luxembourg',
    NA: 'Namur',
    AN: 'Antwerp',
    LM: 'Limburg',
    OV: 'East Flanders',
    WV: 'West Flanders',
};
export const DENMARK_PROVINCE_CODES = {
    H: 'Hovedstaden',
    M: 'Midtjylland',
    N: 'Nordjylland',
    S: 'Sjælland',
    SD: 'Syddanmark',
};
export const FINLAND_PROVINCE_CODES = {
    AL: 'Åland',
    ES: 'South Karelia',
    EP: 'South Ostrobothnia',
    EM: 'South Savo',
    KU: 'Kainuu',
    KA: 'Kanta-Häme',
    KE: 'Central Ostrobothnia',
    KP: 'Central Finland',
    LA: 'Lapland',
    PI: 'Pirkanmaa',
    PO: 'Pohjanmaa',
    PK: 'North Karelia',
    PP: 'North Ostrobothnia',
    PS: 'North Savo',
    PH: 'Päijät-Häme',
    SA: 'Satakunta',
    U: 'Uusimaa',
    VA: 'Varsinais-Suomi',
};
export const FRANCE_PROVINCE_CODES = {
    IDF: 'Île-de-France',
    NAQ: 'Nouvelle-Aquitaine',
    ARA: 'Auvergne-Rhône-Alpes',
    BRE: 'Brittany',
    BFC: 'Bourgogne-Franche-Comté',
    CVL: 'Centre-Val de Loire',
    COR: 'Corsica',
    GES: 'Grand Est',
    HDF: 'Hauts-de-France',
    NOR: 'Normandy',
    OCC: 'Occitanie',
    PAC: 'Provence-Alpes-Côte d’Azur',
    PDL: 'Pays de la Loire',
};
export const GERMANY_PROVINCE_CODES = {
    BW: 'Baden-Württemberg',
    BY: 'Bavaria',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hesse',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Lower Saxony',
    NW: 'North Rhine-Westphalia',
    RP: 'Rhineland-Palatinate',
    SL: 'Saarland',
    SN: 'Saxony',
    ST: 'Saxony-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thuringia',
};
export const NORWAY_PROVINCE_CODES = {
    VIK: 'Viken',
    INN: 'Innlandet',
    TRO: 'Troms og Finnmark',
    NOR: 'Nordland',
    MRO: 'Møre og Romsdal',
    VES: 'Vestfold og Telemark',
    ROG: 'Rogaland',
    VESL: 'Vestland',
    AGD: 'Agder',
    OS: 'Oslo',
    TR: 'Trøndelag',
};
export const SWEDEN_PROVINCE_CODES = {
    AB: 'Stockholm',
    AC: 'Västerbotten',
    BD: 'Norrbotten',
    C: 'Uppsala',
    D: 'Södermanland',
    E: 'Östergötland',
    F: 'Jönköping',
    G: 'Kronoberg',
    H: 'Kalmar',
    I: 'Gotland',
    K: 'Blekinge',
    M: 'Skåne',
    N: 'Halland',
    O: 'Västra Götaland',
    S: 'Värmland',
    T: 'Örebro',
    U: 'Västmanland',
    W: 'Dalarna',
    X: 'Gävleborg',
    Y: 'Västernorrland',
    Z: 'Jämtland',
};
export const SWITZERLAND_PROVINCE_CODES = {
    AG: 'Aargau',
    AI: 'Appenzell Innerrhoden',
    AR: 'Appenzell Ausserrhoden',
    BE: 'Bern',
    BL: 'Basel-Landschaft',
    BS: 'Basel-Stadt',
    FR: 'Fribourg',
    GE: 'Geneva',
    GL: 'Glarus',
    GR: 'Graubünden',
    JU: 'Jura',
    LU: 'Lucerne',
    NE: 'Neuchâtel',
    NW: 'Nidwalden',
    OW: 'Obwalden',
    SG: 'St. Gallen',
    SH: 'Schaffhausen',
    SO: 'Solothurn',
    SZ: 'Schwyz',
    TG: 'Thurgau',
    TI: 'Ticino',
    UR: 'Uri',
    VD: 'Vaud',
    VS: 'Valais',
    ZG: 'Zug',
    ZH: 'Zurich',
};
// more
export const ARGENTINA_PROVINCE_CODES = {
    BA: 'Buenos Aires',
    C: 'Ciudad Autónoma de Buenos Aires',
    CT: 'Catamarca',
    CH: 'Chaco',
    CB: 'Chubut',
    CD: 'Córdoba',
    CR: 'Corrientes',
    ER: 'Entre Ríos',
    FO: 'Formosa',
    JY: 'Jujuy',
    LP: 'La Pampa',
    LR: 'La Rioja',
    MZ: 'Mendoza',
    MN: 'Misiones',
    NQ: 'Neuquén',
    RN: 'Río Negro',
    SA: 'Salta',
    SJ: 'San Juan',
    SL: 'San Luis',
    SC: 'Santa Cruz',
    SF: 'Santa Fe',
    SE: 'Santiago del Estero',
    TF: 'Tierra del Fuego',
    TU: 'Tucumán',
};
export const BOLIVIA_PROVINCE_CODES = {
    BE: 'Beni',
    CH: 'Chuquisaca',
    CB: 'Cochabamba',
    LP: 'La Paz',
    OR: 'Oruro',
    PD: 'Pando',
    PT: 'Potosí',
    SC: 'Santa Cruz',
    TA: 'Tarija',
};
export const BRAZIL_PROVINCE_CODES = {
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SP: 'São Paulo',
    SE: 'Sergipe',
    TO: 'Tocantins',
};
export const CHILE_PROVINCE_CODES = {
    AI: 'Aisén',
    AN: 'Antofagasta',
    AP: 'Arica y Parinacota',
    AT: 'Atacama',
    BI: 'Biobío',
    CO: 'Coquimbo',
    AR: 'Araucanía',
    LI: 'Libertador General Bernardo O’Higgins',
    LL: 'Los Lagos',
    LR: 'Los Ríos',
    MA: 'Magallanes y de la Antártica Chilena',
    ML: 'Maule',
    NB: 'Ñuble',
    RM: 'Región Metropolitana de Santiago',
    TA: 'Tarapacá',
    VS: 'Valparaíso',
};
export const COLOMBIA_PROVINCE_CODES = {
    AM: 'Amazonas',
    AN: 'Antioquia',
    AR: 'Arauca',
    AT: 'Atlántico',
    DC: 'Bogotá',
    BO: 'Bolívar',
    BY: 'Boyacá',
    CA: 'Caldas',
    CQ: 'Caquetá',
    CN: 'Casanare',
    CS: 'Cauca',
    CE: 'Cesar',
    CH: 'Chocó',
    CO: 'Córdoba',
    CU: 'Cundinamarca',
    GU: 'Guainía',
    GD: 'Guaviare',
    HG: 'Huila',
    LG: 'La Guajira',
    MG: 'Magdalena',
    MT: 'Meta',
    NS: 'Nariño',
    SA: 'Santander',
    SU: 'Sucre',
    TO: 'Tolima',
    VA: 'Valle del Cauca',
    VC: 'Vaupés',
    VD: 'Vichada',
};
export const ECUADOR_PROVINCE_CODES = {
    AZ: 'Azuay',
    BO: 'Bolívar',
    CA: 'Cañar',
    CH: 'Carchi',
    CO: 'Cotopaxi',
    EO: 'El Oro',
    ES: 'Esmeraldas',
    GA: 'Galápagos',
    GU: 'Guayas',
    IM: 'Imbabura',
    LO: 'Loja',
    LR: 'Los Ríos',
    MA: 'Manabí',
    MO: 'Morona Santiago',
    NA: 'Napo',
    OR: 'Orellana',
    PA: 'Pastaza',
    PI: 'Pichincha',
    SE: 'Santa Elena',
    SD: 'Santo Domingo de los Tsáchilas',
    SU: 'Sucumbíos',
    TU: 'Tungurahua',
    ZA: 'Zamora Chinchipe',
};
export const PARAGUAY_PROVINCE_CODES = {
    AS: 'Asunción',
    CN: 'Concepción',
    AM: 'Amambay',
    BO: 'Boquerón',
    CR: 'Canindeyú',
    CE: 'Central',
    CG: 'Cordillera',
    GU: 'Guairá',
    IT: 'Itapúa',
    MI: 'Misiones',
    NE: 'Ñeembucú',
    PA: 'Paraguarí',
    PD: 'Presidente Hayes',
    SP: 'San Pedro',
    AP: 'Alto Paraná',
    TA: 'Alto Paraguay',
    CA: 'Caaguazú',
    CU: 'Caazapá',
};
export const PERU_PROVINCE_CODES = {
    AM: 'Amazonas',
    AN: 'Áncash',
    AP: 'Apurímac',
    AR: 'Arequipa',
    AY: 'Ayacucho',
    CA: 'Cajamarca',
    CL: 'Callao',
    CU: 'Cusco',
    HU: 'Huancavelica',
    HP: 'Huánuco',
    IC: 'Ica',
    JU: 'Junín',
    LD: 'La Libertad',
    LM: 'Lambayeque',
    LI: 'Lima',
    LO: 'Loreto',
    MD: 'Madre de Dios',
    MO: 'Moquegua',
    PA: 'Pasco',
    PI: 'Piura',
    PU: 'Puno',
    SM: 'San Martín',
    TA: 'Tacna',
    TU: 'Tumbes',
    UC: 'Ucayali',
};
export const URUGUAY_PROVINCE_CODES = {
    AR: 'Artigas',
    CA: 'Canelones',
    CE: 'Cerro Largo',
    CO: 'Colonia',
    DU: 'Durazno',
    FD: 'Florida',
    FS: 'Flores',
    LA: 'Lavalleja',
    MA: 'Maldonado',
    MO: 'Montevideo',
    PA: 'Paysandú',
    RN: 'Río Negro',
    RV: 'Rivera',
    RO: 'Rocha',
    SA: 'Salto',
    SJ: 'San José',
    SO: 'Soriano',
    TA: 'Tacuarembó',
    TT: 'Treinta y Tres',
};
export const VENEZUELA_PROVINCE_CODES = {
    AM: 'Amazonas',
    AN: 'Anzoátegui',
    AP: 'Apure',
    AR: 'Aragua',
    BA: 'Barinas',
    BO: 'Bolívar',
    CA: 'Carabobo',
    CO: 'Cojedes',
    DA: 'Delta Amacuro',
    DC: 'Distrito Capital',
    FA: 'Falcón',
    GU: 'Guárico',
    LA: 'Lara',
    ME: 'Mérida',
    MI: 'Miranda',
    MO: 'Monagas',
    NE: 'Nueva Esparta',
    PO: 'Portuguesa',
    SU: 'Sucre',
    TA: 'Táchira',
    TR: 'Trujillo',
    VA: 'Vargas',
    YA: 'Yaracuy',
    ZU: 'Zulia',
};
//# sourceMappingURL=provinces.js.map